import {Component, DestroyRef, inject, OnInit, signal} from '@angular/core';
import {ConfigService, NotificationService, TjKeycloakService} from '../../../../core/services';
import {environment} from '../../../../../environments/environment';
import {Area} from '../../../../api/model/Area.model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ApiService} from '../../../../api/service/api.service';

@Component({
  selector: 'tj-include-appLink-configuration',
  templateUrl: './include-app-link-configurations.component.html',
  styleUrls: ['./include-app-link-configurations.component.scss'],
})
export class IncludeAppLinkConfigurationsComponent implements OnInit {
  protected readonly env = environment;

  private api = inject(ApiService);
  private configService = inject(ConfigService);
  private notificationService = inject(NotificationService);
  private destroy$ = inject(DestroyRef);
  private keycloakService = inject(TjKeycloakService);

  protected areas = signal<Area[]>([]);

  constructor() {
  }

  ngOnInit() {
    this.configService.areas$
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe({
        next: areas => {
          this.areas.set(areas);
        }
      });
  }

  updateIncludeAppLinkArea(areaId: number, checked: boolean) {
    if (this.hasPermissionEditIncludeAppLink()) {
      this.notificationService.error('You have not required permission');
      return;
    }
    this.api.area
      .updateIncludeAppLinkArea(areaId, checked)
      .pipe(takeUntilDestroyed(this.destroy$))
      .subscribe(() => {
        this.notificationService.success('Successfully updated');
      });
  }

  hasPermissionEditIncludeAppLink() {
    return !this.keycloakService.hasRole('AREA_APP_LINK_RECEIVE_EDIT');
  }
}
